var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.banner.type,"icon":_vm.banner.icon,"dismissible":"","outline":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.banner.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }